import { restApiIP } from "@plannel/services/utils/rest-api";

const getAllByLocation = (params) => {
  return restApiIP.get("/api/inventory-overview-location", { params });
};

const getAllByCategory = (params) => {
  return restApiIP.get("/api/inventory-overview-category", { params });
};

const inventoryOverviewService = {
  getAllByLocation,
  getAllByCategory
};

export default inventoryOverviewService;